import { Theme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export const SvgIcon = (theme: Theme) => {
  return {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          //opacity: "0.8",
        },
      },
    },
  };
};
